import React from 'react'
import TopBanner from '../../../components/topBanner/topBanner'
import imgBaner from "../../../images/banner/banner---gioi-thieu.png";
import { useState, useEffect } from 'react';
import { useNavigate, Outlet, useParams, useLocation } from 'react-router-dom';
import TitleCenter from '../../../components/title/TitleCenter';
import { useTranslation } from 'react-i18next';
import { normalizeLang } from '../../../utils/localeDataLoader';
import { useLeaderCategoriesQuery, useLeadershipPageMetaQuery } from 'hooks';


function Leaders() {
  const { i18n } = useTranslation();
  const { slug } = useParams();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState("");
  const [currentCategoryId, setCurrentCategoryId] = useState(null);
  const navigate = useNavigate();
  const currentLang = normalizeLang(i18n.language);
  const { data: rawLeaderCategories = [] } = useLeaderCategoriesQuery(currentLang);
  const { data: pageMeta = { pageName: currentLang === 'en' ? "About us" : "Tổng quan", titleCenter: currentLang === 'en' ? "Leadership" : "Ban lãnh đạo" } } = useLeadershipPageMetaQuery(currentLang);
  const { pageName, titleCenter } = pageMeta;
  const activeSlug = slug || location.pathname.split('/').filter(Boolean).pop();
  const isShareholderCouncil = location.pathname.startsWith('/co-dong/hoi-dong-co-dong')
    || location.pathname.startsWith('/shareholders/shareholder-council');
  const basePath = isShareholderCouncil
    ? (currentLang === 'vi' ? '/co-dong/hoi-dong-co-dong' : '/shareholders/shareholder-council')
    : (currentLang === 'vi' ? '/tong-quan/ban-lanh-dao' : '/about-us/leadership');

  const leaderCategorys = isShareholderCouncil
    ? rawLeaderCategories.filter(cat => {
        const catSlug = (cat?.slug || '').toLowerCase();
        const catName = (cat?.name || cat?.Name || '').toLowerCase();
        return !catSlug.includes('so-do-to-chuc') &&
               !catSlug.includes('organization-chart') &&
               !catName.includes('sơ đồ tổ chức') &&
               !catName.includes('organization chart');
      })
    : rawLeaderCategories;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  // Effect 1: Gọi API khi ngôn ngữ thay đổi, điều hướng về đúng slug theo ngôn ngữ mới
  useEffect(() => {
    if (!leaderCategorys.length) return;

    let target;
    if (activeSlug === 'so-do-to-chuc' || activeSlug === 'organization-chart') {
      target = { slug: currentLang === 'vi' ? 'so-do-to-chuc' : 'organization-chart', name: currentLang === 'vi' ? 'Sơ đồ tổ chức' : 'Organization Chart', id: null };
    } else {
      // Ưu tiên giữ nguyên category theo ID khi đổi ngôn ngữ; fallback về slug khi load lần đầu
      // Thử tìm theo slug hiện tại trước (áp dụng khi load trang hoặc chuyển tab/back button)
      let found = activeSlug ? leaderCategorys.find(item => item.slug === activeSlug) : null;
      // Nếu không thấy theo slug (do đổi ngôn ngữ, slug cũ không tồn tại ở ngôn ngữ mới), thì tìm theo ID
      if (!found && currentCategoryId) {
        found = leaderCategorys.find(item => item.id === currentCategoryId);
      }
      target = found || leaderCategorys[0];
    }

    setActiveMenu(target.name);
    setCurrentCategoryId(target.id !== undefined ? target.id : null);
    if (activeSlug !== target.slug) {
      navigate(`${basePath}/${target.slug}`, { replace: true });
    }
  }, [currentLang, leaderCategorys, currentCategoryId, activeSlug, navigate, basePath]);

  const handleCategoriOnclick = (category) => {
    navigate(`${basePath}/${category.slug}`);
    setActiveMenu(category.name);
    setCurrentCategoryId(category.id);
  };
  return (
    <div className='leadership_controller'>
      <TopBanner
        imgBanner={imgBaner}
        pageName={pageName}
        titleCenter={titleCenter}
        text={activeMenu}
      />
      <div className='layout_container'>
        <TitleCenter
          text={activeMenu}
        />
        <ul className="category">
          {
            leaderCategorys.map((value, index) => (
              <li
                className={activeSlug === value.slug ? "category-active categori_border" : "categori_border"}
                key={value.id || index}
                onClick={() => handleCategoriOnclick(value)}
                role="button"
                tabIndex={0}
                aria-current={activeSlug === value.slug ? 'page' : undefined}
                title={value.name || value.Name || 'Đang cập nhật'}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') handleCategoriOnclick(value);
                }}
              >
                {value.name || value.Name || 'Đang cập nhật'}
              </li>
            ))
          }
        </ul>
        <Outlet context={{
          currentCategoryId,
          currentCategorySlug: leaderCategorys.find(c => c.id === currentCategoryId)?.slug || activeSlug
        }} />
      </div>
    </div>
  )
}

export default Leaders
